import React from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'gatsby'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Stack from 'react-bootstrap/Stack'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { AccountAddressElement, AddressElement } from '/src/components/commerce/form/elements'
import { TextInput, IconButton } from '/src/components/common'
import { StoreSelector } from '/src/components/commerce'
import { postRequest } from '/src/httpClient'

// @todo, update addresses.
export const AccountAddressForm = ({ user, cart }) => {
  const {
    control,
    register,
    formState: { errors },
    setValue,
    getValues,
    setError,
    watch,
    handleSubmit
  } = useForm()

  const onSubmit = (data) => {
    console.log(data)
  }

  return (
    <div className="account-form-container">
      <form id="account-address-form" onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-4">
          <Col sm={12}>
            <label className="mb-2">Your Store</label>
            <StoreSelector user={user} control={control} />
          </Col>
        </Row>
        {user && !user.trade_name && (
          <Row>
            <Col sm={12}>
              <AccountAddressElement 
                label="Your delivery addresses"
                cart={cart}
                control={control} 
                register={register}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              />
            </Col>
          </Row>
        )}
      </form>
    </div>
  )
}

export default AccountAddressForm